import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const Filter: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M11.0496 18C10.7664 18 10.5208 17.896 10.3128 17.688C10.104 17.4792 9.9996 17.2332 9.9996 16.95C9.9996 16.6668 10.104 16.4208 10.3128 16.212C10.5208 16.004 10.7664 15.9 11.0496 15.9H12.9504C13.2336 15.9 13.4792 16.004 13.6872 16.212C13.896 16.4208 14.0004 16.6668 14.0004 16.95C14.0004 17.2332 13.896 17.4792 13.6872 17.688C13.4792 17.896 13.2336 18 12.9504 18H11.0496ZM4.05 8.1C3.7668 8.1 3.5208 7.996 3.312 7.788C3.104 7.5792 3 7.3332 3 7.05C3 6.7668 3.104 6.5208 3.312 6.312C3.5208 6.104 3.7668 6 4.05 6H19.95C20.2332 6 20.4792 6.104 20.688 6.312C20.896 6.5208 21 6.7668 21 7.05C21 7.3332 20.896 7.5792 20.688 7.788C20.4792 7.996 20.2332 8.1 19.95 8.1H4.05ZM7.05 13.05C6.7668 13.05 6.5208 12.946 6.312 12.738C6.104 12.5292 6 12.2832 6 12C6 11.7168 6.104 11.4708 6.312 11.262C6.5208 11.054 6.7668 10.95 7.05 10.95H16.9752C17.2584 10.95 17.504 11.054 17.712 11.262C17.9208 11.4708 18.0252 11.7168 18.0252 12C18.0252 12.2832 17.9208 12.5292 17.712 12.738C17.504 12.946 17.2584 13.05 16.9752 13.05H7.05Z' fill='currentColor' />
  </svg>
);

export default Filter;
